import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import { App } from './views/App';
import {
  ContextMenuProvider,
  MessageProvider,
  ModalProvider,
  SideDialogProvider,
  ThemeProvider,
  TooltipProvider,
} from './context';

import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ThemeProvider>
    <MessageProvider>
      <TooltipProvider>
        <SideDialogProvider>
          <ModalProvider>
            <ContextMenuProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ContextMenuProvider>
          </ModalProvider>
        </SideDialogProvider>
      </TooltipProvider>
    </MessageProvider>
  </ThemeProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
